"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AVAILABILITY_API_RESPONSE_400 = exports.AVAILABILITY_API_RESPONSE_200__DATED = exports.AVAILABILITY_API_RESPONSE_200__WITH_PARKS__UNDATED = exports.AVAILABILITY_API_RESPONSE_200__WITH_LODGES_AND_PARKS_GROUPS__UNDATED = exports.AVAILABILITY_API_RESPONSE_200__WITH_LODGES_GROUP__UNDATED = exports.AVAILABILITY_API_RESPONSE_200__UNDATED = exports.AVAILABILITY_API_VERSION = void 0;
// HACK: This is to avoid renaming exports until we have a customised eslint config
/* eslint-disable @typescript-eslint/naming-convention */
exports.AVAILABILITY_API_VERSION = 'x.x.x';
exports.AVAILABILITY_API_RESPONSE_200__UNDATED = {
    lengthOfStay: 7,
    propertyCode: 'UKC3275',
    fromPrice: {
        price: 785,
    },
    availability: {
        '2023-05-02': {
            price: 1369.0,
        },
        '2023-08-18': {
            price: 2495.0,
        },
        '2023-11-29': {
            price: 945.0,
        },
        '2023-03-02': {
            price: 965.0,
        },
        '2023-11-26': {
            price: 945.0,
        },
        '2023-12-08': {
            price: 949.0,
        },
        '2023-09-23': {
            price: 1145.0,
        },
        '2023-01-24': {
            price: 939.0,
        },
        '2022-12-28': {
            price: 1515.0,
        },
        '2023-02-02': {
            price: 929.0,
        },
        '2023-11-11': {
            price: 925.0,
        },
        '2023-09-25': {
            price: 1145.0,
        },
        '2023-06-02': {
            price: 1865.0,
        },
        '2023-05-07': {
            price: 1615.0,
        },
        '2023-11-23': {
            price: 945.0,
        },
        '2023-11-19': {
            price: 925.0,
        },
        '2023-10-05': {
            price: 1109.0,
        },
        '2022-11-17': {
            price: 849.0,
        },
        '2023-10-27': {
            price: 1365.0,
        },
        '2023-11-24': {
            price: 945.0,
        },
        '2023-11-10': {
            price: 925.0,
        },
        '2022-11-04': {
            price: 849.0,
        },
        '2023-11-16': {
            price: 925.0,
        },
        '2023-03-24': {
            price: 975.0,
        },
        '2023-02-03': {
            price: 929.0,
        },
        '2023-10-03': {
            price: 1109.0,
        },
        '2023-06-13': {
            price: 1825.0,
        },
        '2023-06-20': {
            price: 1835.0,
        },
        '2023-10-02': {
            price: 1109.0,
        },
        '2023-07-28': {
            price: 2695.0,
        },
        '2023-09-19': {
            price: 1139.0,
        },
        '2023-09-08': {
            price: 1205.0,
        },
        '2023-06-09': {
            price: 1825.0,
        },
        '2023-08-11': {
            price: 2745.0,
        },
        '2023-04-29': {
            price: 1369.0,
        },
        '2023-10-04': {
            price: 1109.0,
        },
        '2023-05-03': {
            price: 1369.0,
        },
        '2023-12-28': {
            price: 1459.0,
        },
        '2023-02-28': {
            price: 965.0,
        },
        '2023-09-20': {
            price: 1139.0,
        },
        '2023-09-18': {
            price: 1139.0,
        },
        '2023-10-13': {
            price: 1119.0,
        },
        '2023-05-04': {
            price: 1615.0,
        },
        '2023-02-24': {
            price: 965.0,
        },
        '2023-06-19': {
            price: 1835.0,
        },
        '2023-01-15': {
            price: 939.0,
        },
        '2023-07-21': {
            price: 2695.0,
        },
        '2022-12-20': {
            price: 1485.0,
        },
        '2022-12-09': {
            price: 839.0,
        },
        '2023-09-15': {
            price: 1139.0,
        },
        '2023-04-21': {
            price: 1219.0,
        },
        '2023-02-21': {
            price: 929.0,
        },
        '2023-11-15': {
            price: 925.0,
        },
        '2023-11-05': {
            price: 925.0,
        },
        '2023-03-10': {
            price: 965.0,
        },
        '2023-03-08': {
            price: 965.0,
        },
        '2023-06-10': {
            price: 1825.0,
        },
        '2023-06-07': {
            price: 1865.0,
        },
        '2023-11-22': {
            price: 925.0,
        },
        '2023-02-19': {
            price: 929.0,
        },
        '2023-01-05': {
            price: 939.0,
        },
        '2023-02-17': {
            price: 929.0,
        },
        '2023-01-18': {
            price: 939.0,
        },
        '2023-01-08': {
            price: 939.0,
        },
        '2023-11-07': {
            price: 925.0,
        },
        '2023-05-05': {
            price: 1615.0,
        },
        '2023-05-09': {
            price: 1615.0,
        },
        '2023-11-28': {
            price: 945.0,
        },
        '2023-02-23': {
            price: 965.0,
        },
        '2023-06-08': {
            price: 1825.0,
        },
        '2023-11-21': {
            price: 925.0,
        },
        '2023-06-05': {
            price: 1865.0,
        },
        '2023-06-12': {
            price: 1825.0,
        },
        '2023-04-25': {
            price: 1219.0,
        },
        '2022-06-14': {
            price: 1649.0,
        },
        '2023-05-01': {
            price: 1369.0,
        },
        '2023-07-14': {
            price: 2175.0,
        },
        '2023-11-25': {
            price: 945.0,
        },
        '2023-11-13': {
            price: 925.0,
        },
        '2023-03-04': {
            price: 965.0,
        },
        '2023-06-21': {
            price: 1835.0,
        },
        '2023-10-01': {
            price: 1109.0,
        },
        '2023-08-25': {
            price: 1699.0,
        },
        '2023-11-09': {
            price: 925.0,
        },
        '2023-01-25': {
            price: 939.0,
        },
        '2023-01-12': {
            price: 939.0,
        },
        '2023-01-26': {
            price: 935.0,
        },
        '2022-06-17': {
            price: 1525.0,
        },
        '2023-06-16': {
            price: 1835.0,
        },
        '2023-11-30': {
            price: 945.0,
        },
        '2023-03-01': {
            price: 965.0,
        },
        '2023-01-21': {
            price: 939.0,
        },
        '2023-06-30': {
            price: 2175.0,
        },
        '2023-11-20': {
            price: 925.0,
        },
        '2023-01-31': {
            price: 935.0,
        },
        '2023-07-07': {
            price: 2155.0,
        },
        '2023-05-06': {
            price: 1615.0,
        },
        '2023-06-17': {
            price: 1835.0,
        },
        '2023-09-24': {
            price: 1145.0,
        },
        '2023-11-08': {
            price: 925.0,
        },
        '2023-01-17': {
            price: 939.0,
        },
        '2023-03-06': {
            price: 965.0,
        },
        '2023-02-16': {
            price: 929.0,
        },
        '2023-09-28': {
            price: 1109.0,
        },
        '2023-04-07': {
            price: 1605.0,
        },
        '2023-10-06': {
            price: 1109.0,
        },
        '2023-03-31': {
            price: 1605.0,
        },
        '2023-11-04': {
            price: 925.0,
        },
        '2022-10-28': {
            price: 1095.0,
        },
        '2023-12-21': {
            price: 1715.0,
        },
        '2023-04-14': {
            price: 1219.0,
        },
        '2023-06-15': {
            price: 1835.0,
        },
        '2023-01-10': {
            price: 939.0,
        },
        '2023-03-17': {
            price: 969.0,
        },
        '2023-06-23': {
            price: 2065.0,
        },
        '2023-08-04': {
            price: 2695.0,
        },
        '2023-05-11': {
            price: 1615.0,
        },
        '2023-06-11': {
            price: 1825.0,
        },
        '2023-03-07': {
            price: 965.0,
        },
        '2022-11-14': {
            price: 849.0,
        },
        '2022-11-16': {
            price: 849.0,
        },
        '2023-04-24': {
            price: 1219.0,
        },
        '2023-02-25': {
            price: 965.0,
        },
        '2023-09-27': {
            price: 1145.0,
        },
        '2023-05-10': {
            price: 1615.0,
        },
        '2023-01-19': {
            price: 939.0,
        },
        '2023-09-30': {
            price: 1109.0,
        },
        '2022-11-13': {
            price: 849.0,
        },
        '2023-04-22': {
            price: 1219.0,
        },
        '2023-03-05': {
            price: 965.0,
        },
        '2023-01-22': {
            price: 939.0,
        },
        '2023-11-03': {
            price: 925.0,
        },
        '2023-01-11': {
            price: 939.0,
        },
        '2023-01-23': {
            price: 939.0,
        },
        '2023-09-16': {
            price: 1139.0,
        },
        '2023-06-22': {
            price: 2065.0,
        },
        '2023-09-29': {
            price: 1109.0,
        },
        '2023-01-16': {
            price: 939.0,
        },
        '2023-02-27': {
            price: 965.0,
        },
        '2023-01-29': {
            price: 935.0,
        },
        '2023-01-20': {
            price: 939.0,
        },
        '2023-09-01': {
            price: 1309.0,
        },
        '2023-04-28': {
            price: 1369.0,
        },
        '2023-02-26': {
            price: 965.0,
        },
        '2023-04-23': {
            price: 1219.0,
        },
        '2023-11-18': {
            price: 925.0,
        },
        '2023-11-14': {
            price: 925.0,
        },
        '2022-06-15': {
            price: 1649.0,
        },
        '2023-02-20': {
            price: 929.0,
        },
        '2023-01-13': {
            price: 939.0,
        },
        '2023-03-03': {
            price: 965.0,
        },
        '2023-05-19': {
            price: 1615.0,
        },
        '2023-09-21': {
            price: 1145.0,
        },
        '2023-04-26': {
            price: 1219.0,
        },
        '2023-11-17': {
            price: 925.0,
        },
        '2023-12-01': {
            price: 945.0,
        },
        '2023-11-12': {
            price: 925.0,
        },
        '2023-04-27': {
            price: 1369.0,
        },
        '2023-01-07': {
            price: 939.0,
        },
        '2023-06-14': {
            price: 1825.0,
        },
        '2023-09-17': {
            price: 1139.0,
        },
        '2023-10-20': {
            price: 1365.0,
        },
        '2023-02-18': {
            price: 929.0,
        },
        '2023-06-06': {
            price: 1865.0,
        },
        '2023-01-06': {
            price: 939.0,
        },
        '2023-06-18': {
            price: 1835.0,
        },
        '2023-05-12': {
            price: 1615.0,
        },
        '2023-11-27': {
            price: 945.0,
        },
        '2023-11-06': {
            price: 925.0,
        },
        '2023-01-28': {
            price: 935.0,
        },
        '2022-06-16': {
            price: 1525.0,
        },
        '2023-09-26': {
            price: 1145.0,
        },
        '2023-05-26': {
            price: 2055.0,
        },
        '2023-04-30': {
            price: 1369.0,
        },
        '2023-06-03': {
            price: 1865.0,
        },
        '2023-05-08': {
            price: 1615.0,
        },
        '2023-01-04': {
            price: 1405.0,
        },
        '2023-09-22': {
            price: 1145.0,
        },
        '2023-03-09': {
            price: 965.0,
        },
        '2022-11-15': {
            price: 849.0,
        },
        '2023-01-30': {
            price: 935.0,
        },
        '2023-01-09': {
            price: 939.0,
        },
        '2023-02-01': {
            price: 935.0,
        },
        '2023-01-27': {
            price: 935.0,
        },
        '2023-02-22': {
            price: 929.0,
        },
        '2023-01-14': {
            price: 939.0,
        },
        '2023-06-04': {
            price: 1865.0,
        },
    },
};
const availabilityEntries = Object.entries(exports.AVAILABILITY_API_RESPONSE_200__UNDATED.availability);
const availabilityArrayWithUnitCode = availabilityEntries.map(([key, value]) => ({
    [key]: {
        ...value,
        unitCode: 'LP14313',
    },
}));
const availabilityWithUnitCode = availabilityArrayWithUnitCode.reduce((obj, item) => {
    const itemKey = Object.keys(item)[0];
    const itemObject = Object.values(item)[0];
    return Object.assign(obj, { [itemKey]: itemObject });
}, {});
exports.AVAILABILITY_API_RESPONSE_200__WITH_LODGES_GROUP__UNDATED = {
    availability: availabilityWithUnitCode,
    groups: ['LODGES'],
    lengthOfStay: 7,
    propertyCode: 'LP14313',
    fromPrice: {
        price: 785,
    },
};
exports.AVAILABILITY_API_RESPONSE_200__WITH_LODGES_AND_PARKS_GROUPS__UNDATED = {
    availability: availabilityWithUnitCode,
    groups: ['LODGES', 'PARKS'],
    lengthOfStay: 7,
    propertyCode: 'LP14313',
    fromPrice: {
        price: 785,
    },
};
exports.AVAILABILITY_API_RESPONSE_200__WITH_PARKS__UNDATED = {
    availability: availabilityWithUnitCode,
    groups: ['PARKS'],
    lengthOfStay: 7,
    propertyCode: 'LP14313',
    fromPrice: {
        price: 785,
    },
};
exports.AVAILABILITY_API_RESPONSE_200__DATED = {
    lengthOfStay: 7,
    propertyCode: 'LP14313',
    searchDate: {
        price: 785,
        wasPrice: 977,
        startDate: '2023-11-11',
    },
    availability: exports.AVAILABILITY_API_RESPONSE_200__UNDATED.availability,
};
exports.AVAILABILITY_API_RESPONSE_400 = {
    errors: [
        {
            message: 'propertyCode must not be empty',
        },
        {
            message: 'lengthOfStay must be between 1 and 28',
        },
    ],
    type: 'VALIDATION_ERROR',
};
/* eslint-enable */
//# sourceMappingURL=availability.js.map